var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UIBtn',_vm._b({staticClass:"relative",attrs:{"icon":_vm.btnIcon},on:{"click":function($event){_vm.isOpen=!_vm.isOpen}}},'UIBtn',Object.assign({}, _vm.$attrs),false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }